import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import { useCallback } from 'react'

import { ApprovalNotificationRequest } from './approvalNotifications'

const NOTIFICATIONS_PATH = '/api/v1/notifications'

/** Failures are logged, not thrown: the save or signature they follow already succeeded. */
export function useApprovalNotifications() {
  const { ALERTS_URL } = useRuntimeVariables()
  const { authorizedAxios } = useGeckoAuth()

  return useCallback(
    async (requests: readonly ApprovalNotificationRequest[]) => {
      if (!ALERTS_URL) return
      const results = await Promise.allSettled(
        requests.map((request) =>
          authorizedAxios.post(`${ALERTS_URL}${NOTIFICATIONS_PATH}`, request, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          })
        )
      )
      for (const result of results) {
        if (result.status === 'rejected') {
          console.error('Failed to send approval notification:', result.reason)
        }
      }
    },
    [ALERTS_URL, authorizedAxios]
  )
}
